var resourceFilter = {};
(function (resourceFilterApp) {
    var filterModel = {
        Subject: "",
        FileType: "",
        Page: 1,
        SearchTerm: ""
    };
    var fromPopState = false;
    var blockPopstateEvent = true;
    var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            var currentPath = window.location.pathname;
            var query = "?";
            var queryArray = [];

            if (filterModel.Subject) {
                queryArray.push("subject=" + filterModel.Subject);
            }
            if (filterModel.FileType) {
                queryArray.push("filetype=" + filterModel.FileType);
            }
            if (filterModel.SearchTerm) {
                queryArray.push("search=" + filterModel.SearchTerm);
            }
            if (filterModel.Page && filterModel.Page > 1) {
                queryArray.push("page=" + filterModel.Page);
            }

            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.Subject = "";
        filterModel.FileType = "";
        filterModel.SearchTerm = "";
        filterModel.Page = 1;
        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                var key = decodeURIComponent(aItKey[0]).toLowerCase();
                var val = decodeURIComponent(aItKey[1]);

                if (key === "subject") {
                    filterModel.Subject = val;
                } else if (key === "filetype") {
                    filterModel.FileType = val;
                } else if (key === "search") {
                    filterModel.SearchTerm = val;
                } else if (key === "page") {
                    filterModel.Page = val;
                }
            }
        }

        resourceFilterApp.SetFilterFields();
        resourceFilterApp.GetResources();
    }

    resourceFilterApp.GetResources = function () {
        $.ajax({
            url: "/umbraco/surface/ResourceSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-resource-filter-results").html(data);
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    resourceFilterApp.SetFilterFields = function () {
        resourceFilterApp.clearFilters();

        if (filterModel.Subject) {
            let subjectArray = filterModel.Subject.split(',');
            resourceFilterApp.SetFilters(subjectArray, "subject")
        }

        if (filterModel.FileType) {
            let fileTypeArray = filterModel.FileType.split(',');
            resourceFilterApp.SetFilters(fileTypeArray, "filetype")
        }

        $('.js-search-term').val(filterModel.SearchTerm);
    };

    resourceFilterApp.SetFilters = function (filterArray, filterType) {
        $.each(filterArray, function (index, value) {
            let filterElement = $(`.js-filter-item[value='${value}']`);
            let buttonText = filterElement.text();
            let buttonValue = filterElement.val();
            if (buttonText != null && buttonText !== "" && buttonValue != null && buttonValue !== "") {
                resourceFilterApp.addFilter(buttonText, buttonValue, filterType);
                filterElement.prop('disabled', true);
            }
        });
    };

    resourceFilterApp.clearFilters = function () {
        $('.js-selected-filters').empty();
        $('.js-filter-item').each(function () {
            $(this).prop('disabled', false);
        });
    }

    resourceFilterApp.addFilter = function (buttonText, buttonValue, filterType) {
        let filterMarkup =
            `<button class="button button--outline js-selected-filter" type="button" value="${buttonValue}" name="${buttonValue}" data-type="${filterType}">
                    ${buttonText}
                    <svg class="icon" role="presentation">
                        <use xlink:href="#icon-cross"></use>
                    </svg>
                </button>`
        $('.js-selected-filters').append(filterMarkup)
    }


    $(document).ready(function () {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('subject'))
            filterModel.Subject = urlParams.get('subject');

        if (urlParams.get('filetype'))
            filterModel.FileType = urlParams.get('filetype');

        if (urlParams.get('search'))
            filterModel.SearchTerm = urlParams.get('search');

        if (urlParams.get('page'))
            filterModel.Page = urlParams.get('page');


        $(document).on("submit", ".js-resource-filter-form", function (e) {
            e.preventDefault();
            populateFilterModel();
            setSecondaryFitersVisibility();
            resourceFilterApp.GetResources();
        });

        $(document).on('click', '.js-filter-item', function (e) {
            let buttonText = $(this).text();
            let buttonValue = $(this).val();
            let filterType = $(this).data('type');
            $(this).prop('disabled', true);
            resourceFilterApp.addFilter(buttonText, buttonValue, filterType);
            populateFilterModel();
            setSecondaryFitersVisibility();
            resourceFilterApp.GetResources();
        });

        $(document).on('click', '.js-selected-filter', function (e) {
            $(this).remove();
            let buttonValue = $(this).val();
            $(`#${buttonValue}`).prop('disabled', false);
            populateFilterModel();
            setSecondaryFitersVisibility();
            resourceFilterApp.GetResources();
        });

        $(document).on('click', '.js-clear-all-filters', function (e) {
            resourceFilterApp.clearFilters();
            populateFilterModel();
            setSecondaryFitersVisibility();
            resourceFilterApp.GetResources();
        });


        function populateFilterModel() {
            let subjects = [];
            let fileTypes = [];
            $(".js-selected-filter[data-type='subject']").each(function () {
                subjects.push($(this).val())
            });
            $(".js-selected-filter[data-type='filetype']").each(function () {
                fileTypes.push($(this).val())
            });
            filterModel.Subject = subjects.join(",");
            filterModel.FileType = fileTypes.join(",");
            filterModel.SearchTerm = $('.js-search-term').val();
            filterModel.Page = 1;
        }

        $(document).on('click', 'ul.pagination a', function (e) {
            e.preventDefault();
            filterModel.Page = $(this).data('page');
            resourceFilterApp.GetResources();
            paginationScrollToTop();
        });

        function paginationScrollToTop() {
            $('html, body').animate({
                scrollTop: $(".js-resource-filter-results").offset().top
            }, 400);
        }

        function setSecondaryFitersVisibility() {
            var currentSelctedFitersElement = $('.js-secondary-filters');

            if (currentSelctedFitersElement.find('.js-selected-filter').length > 0) {
                currentSelctedFitersElement.show();
            } else {
                currentSelctedFitersElement.hide();
            }
        }
    });

})(resourceFilter);
